module.exports = __webpack_public_path__ + "img/patho-F.eca0053f.svg";